//let dpr = window.devicePixelRatio;
let dpr = 1;
class Particle{
	constructor( id, topD ){
		this.id = id;
		this.ratio	= Math.random() * 2 + 1;
		this.size 	= 16*this.ratio*dpr;
		this.pos 	= [0, 0];
		this.pos[0] = Math.floor( Math.random()* particles.cvs.clientWidth*dpr + this.size/2);
		this.pos[1] = Math.floor( Math.random()* particles.cvs.clientHeight*dpr + this.size/2);
		this.currentY = this.pos[1];
		this.ratioY = this.pos[1]/particles.cvs.clientHeight*2;
		this.angle 	= Math.random() * Math.PI * 2;
		this.opacity = Math.random()*100 / 100;
		this.opacity = this.opacity > 1 ? 1 : this.opacity;
		this.resetPosY = 0;
		this.update(window.pageYOffset);
		//console.log(this.pos)
	}
	update( topD ){
		//this.pos[1] -= 1;
		this.currentY = this.pos[1] - (topD - this.resetPosY)*this.ratio/2;
		if( this.id === 0 ){
			//console.log(this.currentY, particles.cvs.clientHeight);
		}
		if( this.currentY < -this.size ){
			this.resetPosY 	= topD;
			this.pos[1] 	= particles.cvs.clientHeight*dpr + this.size;
			this.pos[0] 	= Math.floor( Math.random()* particles.cvs.clientWidth*dpr + this.size/2);
			
		}
		if( this.currentY >= particles.cvs.clientHeight*dpr + 50 ){
			this.resetPosY 	= topD;
			this.pos[1] 	= Math.floor( Math.random()* particles.cvs.clientHeight*dpr);
		}
		this.draw();
	}
	
	draw(){
		particles.ctx.save();
		
		// パーティクルの中心に基準点を移動
		particles.ctx.translate(this.pos[0], this.currentY);
		// パーティクルを回転
		particles.ctx.rotate(this.angle);
		
		particles.ctx.beginPath();
		particles.ctx.moveTo(0, 0);
		particles.ctx.lineTo(-this.size / 2, this.size);
		particles.ctx.lineTo(this.size / 2, this.size);
		particles.ctx.closePath();
		particles.ctx.fillStyle = `rgba(255, 255, 255, ${this.opacity})`;
		particles.ctx.fill();
		
		particles.ctx.restore();
	}
}
export let particles = {
	target: null,
	arry: [],
	frameID: 0,
	dom: null,
	cvs: null,
	ctx: null,
	init: function( topD ){
		particles.dom = document.querySelector("#bg_particles");
		particles.cvs = particles.dom.querySelector("canvas");
		particles.ctx = particles.cvs.getContext("2d");
		for(let i = 0; i < 18; i++){
			particles.arry[i] = new Particle(i, topD);
		}
		particles.resize();
	},
	resize: function(){
		let p 	= particles.cvs;
		let w = particles.dom.clientWidth;
		let h = particles.dom.clientHeight;
		p.setAttribute("width", w*dpr);
		p.setAttribute("height", h*dpr);
		p.style.width 	= w + "px";
		p.style.height 	= h + "px";
	},
	update: function( topD ){
		particles.ctx.clearRect(0, 0, particles.cvs.width, particles.cvs.height);
		particles.resize();
		particles.arry.forEach( ( p, index) => {
			p.update( topD );
		});
	}
}

function getRandom(min, max) {
	return Math.random() * (max - min) + min;
}